import type { ReactNode } from 'react'
import { Check, Languages } from 'lucide-react'

import type { Locale } from '../i18n'

export function AuthLayout({ locale, setLocale, go, children }: { locale: Locale; setLocale: (locale: Locale) => void; go: (path: string) => void; children: ReactNode }) {
  const navigate = (event: React.MouseEvent<HTMLAnchorElement>, path: string) => { event.preventDefault(); go(path) }
  return <div className="auth-page">
    <aside className="auth-art">
      <a href="/" className="brand" onClick={event => navigate(event, '/')}><span className="brand-mark"><Check size={18} strokeWidth={3} /></span><span>TopCaptcha</span></a>
      <div><span className="eyebrow">TOPCAPTCHA CLOUD</span><h2>{locale === 'en' ? 'CAPTCHA infrastructure for production teams' : '为生产业务准备的验证码基础设施'}</h2><p>{locale === 'en' ? 'One secure identity for the customer console, API keys, billing, and support.' : '一个安全身份即可访问客户控制台、API 密钥、账单与支持。'}</p></div>
      <img src="/topcaptcha-analyst.png" alt="TopCaptcha operations analyst" />
    </aside>
    <main className="auth-main">
      <div className="auth-top">
        <a href="/" className="text-link" onClick={event => navigate(event, '/')}>← TopCaptcha</a>
        <div className="locale-switch" aria-label="Language"><Languages size={16} /><button className={locale === 'en' ? 'active' : ''} onClick={() => setLocale('en')}>EN</button><button className={locale === 'zh-CN' ? 'active' : ''} onClick={() => setLocale('zh-CN')}>中文</button></div>
      </div>
      {children}
    </main>
  </div>
}
